




























import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiCard from "../common/AsiCard.vue";
import {Icon} from "@/helpers/icons";
import Bill from "@/models/bill/Bill";
import BillSendLog from "@/models/billSendLog/BillSendLog";
import {BillSendLogType} from "@/helpers/constants";
import UserSimple from "@/models/user/UserSimple";

@Component({
	components: {AsiCard}
})
export default class BillCardSendLogs extends Vue {

	@Prop({type: Object, required: true})
	public bill!: Bill;

	private icons = Icon;

	private typeIcon(sendLog: BillSendLog): string {
		return sendLog.type === BillSendLogType.email ? this.icons.email : this.icons.print;
	}

	private userFullName(user: UserSimple): string | null {
		return UserSimple.fullName(user);
	}

}
